module.exports = __webpack_public_path__ + "img/NKI.681035ff.svg";